import Field from '@/components/formFields/InputField/Field'
import TextArea from '@/components/formFields/TextArea'

const TechTextFields = ({ tech, formHandler, isLoading, updateTechnology }) => {
  return (
    <div className="row">
           <Field
            label={"nameAR"}
            name={"name"}
            className="col-lg-6"
            formHandler={formHandler}
            defaultValue={tech?.name}
            value={tech?.name}
            setValue={(value) => updateTechnology(tech.id , 'name', value?.value) } />

          <Field
            label={"nameEN"}
            name={"nameEN"}
            lang="En"
            className="col-lg-6"
            formHandler={formHandler}
            defaultValue={tech?.nameEN || tech?.name}
            value={tech?.nameEN}
            setValue={(value) => updateTechnology(tech.id , 'nameEN', value?.value) } />

          <TextArea
            className="col-lg-12"
            label={"description"}
            value={tech.description || ""}
            formHandler={formHandler}
            name={`${tech.id}-description`}
            defaultValue={tech.description }
            setValue={(value) => updateTechnology(tech.id , 'description', value) } />

          <TextArea
            className="col-lg-12"
            label={"descriptionEN"}
            lang="En"
            formHandler={formHandler}
            value={tech.descriptionEN || ""}
            name={`${tech.id}-descriptionEN`}
            defaultValue={tech.descriptionEN }
            setValue={(value) => updateTechnology(tech.id , 'descriptionEN', value) } />

    </div>
  )
}

export default TechTextFields